import PropTypes from "prop-types";

import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";

import MDTypography from "components/MDTypography";

/**
 * Batch 2.6 — <BlogFields>. The Blog type block: reading time, canonical URL,
 * featured flag and comment toggle.
 */
function BlogFields({ value, onChange }) {
  return (
    <Stack spacing={3}>
      <MDTypography variant="button" fontWeight="bold" textTransform="uppercase" color="text">
        Blog details
      </MDTypography>

      <TextField
        label="Estimated reading time (minutes)"
        type="number"
        value={value.estimated_reading_time}
        onChange={(e) => onChange({ estimated_reading_time: e.target.value })}
        fullWidth
        inputProps={{ min: 0 }}
      />
      <TextField
        label="External canonical URL"
        value={value.external_canonical_url}
        onChange={(e) => onChange({ external_canonical_url: e.target.value })}
        fullWidth
        helperText="Set when this post was originally published elsewhere"
      />

      <FormControlLabel
        control={
          <Checkbox
            checked={Boolean(value.is_featured)}
            onChange={(e) => onChange({ is_featured: e.target.checked })}
          />
        }
        label="Featured post"
      />
      <FormControlLabel
        control={
          <Checkbox
            checked={Boolean(value.allow_comments)}
            onChange={(e) => onChange({ allow_comments: e.target.checked })}
          />
        }
        label="Allow comments"
      />
    </Stack>
  );
}

BlogFields.defaultProps = {
  websiteId: undefined,
  context: {},
};

BlogFields.propTypes = {
  value: PropTypes.shape({
    estimated_reading_time: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    external_canonical_url: PropTypes.string,
    is_featured: PropTypes.bool,
    allow_comments: PropTypes.bool,
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  websiteId: PropTypes.string,
  context: PropTypes.object,
};

export default BlogFields;
